import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	// mode: 'history',//用history去除地址栏#号 ，默认是hash模式
	routes: [{
			path: '/',
			redirect: '/index'
		},
		{
			path: '/monitor',
			name: 'monitor',
			component: resolve => require(['../views/Monitor/monitor.vue'], resolve),
			meta: {
				title: '监控中心'
			}
		},
		{
			path: '/monitor_3',
			name: 'monitor_3',
			component: resolve => require(['../views/Monitor/monitor_3.vue'], resolve),
			meta: {
				title: '监控中心'
			}
		},
		{
			path: '/alarmMonitor',
			name: 'alarmMonitor',
			component: resolve => require(['../views/Monitor/alarmMonitor.vue'], resolve),
			meta: {
				title: '警情监控中心'
			}
		},
		{
			path: '/',
			component: resolve => require(['../views/main.vue'], resolve),
			meta: {
				title: '首页'
			},
			children: [{
					path: '/index',
					name: 'index',
					component: resolve => require(['../views/Monitor/index.vue'], resolve),
					meta: {
						title: '首页'
					}
				},

				{
					path: '/alarm',
					name: 'alarm',
					component: resolve => require(['../views/Alarm/alarm.vue'], resolve),
					meta: {
						title: '告警中心'
					}
				},

				{
					path: '/device',
					name: 'device',
					component: resolve => require(['../views/Device/device.vue'], resolve),
					meta: {
						title: '设备中心'
					}
				},
				{
					path: '/device_log',
					name: 'device_log',
					component: resolve => require(['../views/Device/device_log.vue'], resolve),
					meta: {
						title: '设备通讯日志'
					}
				},
				{
					path: '/device_cmd_log',
					name: 'device_cmd_log',
					component: resolve => require(['../views/Device/device_cmd_log.vue'], resolve),
					meta: {
						title: '设备命令下发日志'
					}
				},
				{
					path: '/device_config',
					name: 'device_config',
					component: resolve => require(['../views/Device/device_config.vue'], resolve),
					meta: {
						title: '道路精灵参数'
					}
				},
				{
					path: '/requiregoods',
					name: 'requiregoods',
					component: resolve => require(['../views/Sales/requiregoods.vue'], resolve),
					meta: {
						title: '订单申请'
					}
				}, {
					path: '/requiregoodsdetail',
					name: 'requiregoodsdetail',
					component: resolve => require(['../views/Sales/requiregoodsdetail.vue'], resolve),
					meta: {
						title: '订单编辑'
					}
				},

				{
					path: '/delivery_manage',
					name: 'delivery_manage',
					component: resolve => require(['../views/Asset/delivery_manage.vue'], resolve),
					meta: {
						title: '发货管理'
					}
				},
				{
					path: '/deliverydetail',
					name: 'deliverydetail',
					component: resolve => require(['../views/Asset/delivery_detail'], resolve),
					meta: {
						title: '发货编辑'
					}
				},
				{
					path: '/goods_manage',
					name: 'goods_manage',
					component: resolve => require(['../views/Asset/goods_manage.vue'], resolve),
					meta: {
						title: '收货管理'
					}
				},
				{
					path: '/productstoremanage',
					name: 'productstoremanage',
					component: resolve => require(['../views/Asset/productstoremanage.vue'], resolve),
					meta: {
						title: '库存管理'
					}
				},

				{
					path: '/assets_install',
					name: 'assets_install',
					component: resolve => require(['../views/Dispatching/assets_install.vue'], resolve),
					meta: {
						title: '资产安装'
					}
				},
				{
					path: '/assets_install_edit',
					name: 'assets_install_edit',
					component: resolve => require(['../views/Dispatching/assets_install_edit.vue'],
						resolve),
					meta: {
						title: '资产安装编辑'
					}
				},
				{
					path: '/assets_dispatch',
					name: 'assets_dispatch',
					component: resolve => require(['../views/Dispatching/assets_dispatch.vue'],
						resolve),
					meta: {
						title: '派工任务'
					}
				},
				{
					path: '/assets_dispatch_edit',
					name: 'assets_dispatch_edit',
					component: resolve => require(['../views/Dispatching/assets_dispatch_edit.vue'],
						resolve),
					meta: {
						title: '派工编辑'
					}
				},
				{
					path: '/assets_check',
					name: 'assets_check',
					component: resolve => require(['../views/Dispatching/assets_check.vue'], resolve),
					meta: {
						title: '资产验收'
					}
				},
				{
					path: '/assets_check_edit',
					name: 'assets_check_edit',
					component: resolve => require(['../views/Dispatching/assets_check_edit.vue'],
						resolve),
					meta: {
						title: '资产验收编辑'
					}
				},
				{
					path: '/assets_assess',
					name: 'assets_assess',
					component: resolve => require(['../views/Dispatching/assets_assess.vue'], resolve),
					meta: {
						title: '考核评价'
					}
				},
				{
					path: '/assets_assess_edit',
					name: 'assets_assess_edit',
					component: resolve => require(['../views/Dispatching/assets_assess_edit.vue'],
						resolve),
					meta: {
						title: '考核评价编辑'
					}
				},
				{
					path: '/assets_feedback',
					name: 'assets_feedback',
					component: resolve => require(['../views/Dispatching/assets_feedback.vue'],
						resolve),
					meta: {
						title: '任务反馈'
					}
				},
				{
					path: '/assets_feedback_edit',
					name: 'assets_feedback_edit',
					component: resolve => require(['../views/Dispatching/assets_feedback_edit.vue'],
						resolve),
					meta: {
						title: '任务反馈编辑'
					}
				},
				{
					path: '/bill_manage',
					name: 'bill_manage',
					component: resolve => require(['../views/Account/bill_manage.vue'], resolve),
					meta: {
						title: '账单管理'
					}
				},
				{
					path: '/billreport',
					name: 'billreport',
					component: resolve => require(['../views/Account/billreport.vue'], resolve),
					meta: {
						title: '账款统计'
					}
				},


				{
					path: '/newlists',
					name: 'newlists',
					component: resolve => require(['../views/News/newlists.vue'], resolve),
					meta: {
						title: '资讯消息'
					}
				},
				{
					path: '/newsdetail',
					name: 'newsdetail',
					component: resolve => require(['../views/News/newsdetail.vue'], resolve),
					meta: {
						title: '资讯消息'
					}
				},



				{
					path: '/installation_points',
					name: 'installation_points',
					component: resolve => require(['../views/AnalysisData/installation_points.vue'],
						resolve),
					meta: {
						title: '护栏安装点热力图展示'
					}
				},
				{
					path: '/jurisdiction_analysis',
					name: 'jurisdiction_analysis',
					component: resolve => require(['../views/AnalysisData/jurisdiction_analysis.vue'],
						resolve),
					meta: {
						title: '护栏辖区碰撞频次分析'
					}
				},
				{
					path: '/equipments_analysis',
					name: 'equipments_analysis',
					component: resolve => require(['../views/AnalysisData/equipments_analysis.vue'],
						resolve),
					meta: {
						title: '设备保有量分析'
					}
				},
				{
					path: '/unit_statistics',
					name: 'unit_statistics',
					component: resolve => require(['../views/AnalysisData/unit_statistics.vue'],
						resolve),
					meta: {
						title: '设施存量汇总'
					}
				},
				{
					path: '/abnormal_analysis',
					name: 'abnormal_analysis',
					component: resolve => require(['../views/AnalysisData/abnormal_analysis.vue'],
						resolve),
					meta: {
						title: '安装异常分析'
					}
				},
				{
					path: '/alarm_heat_map',
					name: 'alarm_heat_map',
					component: resolve => require(['../views/AnalysisData/alarm_heat_map.vue'],
						resolve),
					meta: {
						title: '告警热力图'
					}
				}, {
					path: '/alarm_time_analysis',
					name: 'alarm_time_analysis',
					component: resolve => require(['../views/AnalysisData/alarm_time_analysis.vue'],
						resolve),
					meta: {
						title: '告警时间段分析'
					}
				}, {
					path: '/alarm_weather_analysis',
					name: 'alarm_weather_analysis',
					component: resolve => require(['../views/AnalysisData/alarm_weather_analysis.vue'],
						resolve),
					meta: {
						title: '告警天气分析'
					}
				},
				{
					path: '/unit_manage',
					name: 'unit_manage',
					component: resolve => require(['../views/Archives/unit_manage.vue'], resolve),
					meta: {
						title: '单位管理'
					}
				},
				{
					path: '/assets',
					name: 'assets',
					component: resolve => require(['../views/Archives/assets.vue'], resolve),
					meta: {
						title: '资产管理'
					}
				},
				{
					path: '/employee_info',
					name: 'employee_info',
					component: resolve => require(['../views/Archives/employee_info.vue'], resolve),
					meta: {
						title: '员工信息'
					}
				},
				{
					path: '/assets_source',
					name: 'assets_source',
					component: resolve => require(['../views/Archives/assets_source.vue'], resolve),
					meta: {
						title: '资产来源'
					}
				},
				{
					path: '/unit_type',
					name: 'unit_type',
					component: resolve => require(['../views/Archives/unit_type.vue'], resolve),
					meta: {
						title: '单位类型'
					}
				},
				{
					path: '/unit_measuring',
					name: 'unit_measuring',
					component: resolve => require(['../views/Archives/unit_measuring.vue'], resolve),
					meta: {
						title: '计量单位'
					}
				},
				{
					path: '/product_type',
					name: 'product_type',
					component: resolve => require(['../views/Archives/product_type.vue'], resolve),
					meta: {
						title: '资产类型'
					}
				},

				{
					path: '/usermanage',
					name: 'usermanage',
					component: resolve => require(['../views/System/usermanage.vue'], resolve),
					meta: {
						title: '用户权限'
					}
				},
				{
					path: '/operatelog',
					name: 'operatelog',
					component: resolve => require(['../views/System/operatelog.vue'], resolve),
					meta: {
						title: '操作日志'
					}
				},
				{
					path: '/404',
					name: '404',
					component: resolve => require(['../views/404.vue'], resolve),
					meta: {
						title: '错误页'
					}
				},

				{
					path: '/remind',
					name: 'remind',
					component: resolve => require(['../views/Remind/remind.vue'], resolve),
					meta: {
						title: '消息提醒'
					}
				},
				{
					path: '/dispatch_type',
					name: 'dispatch_type',
					component: resolve => require(['../views/Archives/dispatch_type.vue'], resolve),
					meta: {
						title: '派工类型'
					}
				},
				{
					path: '/evaluatetype',
					name: 'evaluatetype',
					component: resolve => require(['../views/Archives/evaluatetype.vue'], resolve),
					meta: {
						title: '评价类别'
					}
				},
				{
					path: '/systemparam',
					name: 'systemparam',
					component: resolve => require(['../views/System/systemparam.vue'], resolve),
					meta: {
						title: '基础参数'
					}
				},

				{
					path: '/allot_apply',
					name: 'allot_apply',
					component: resolve => require(['../views/Allot/allot_apply.vue'], resolve),
					meta: {
						title: '调拨管理'
					}
				},
				{
					path: '/allot_apply_detail',
					name: 'allot_apply_detail',
					component: resolve => require(['../views/Allot/allot_apply_detail'], resolve),
					meta: {
						title: '调拨编辑'
					}
				},
				{
					path: '/allot_out',
					name: 'allot_out',
					component: resolve => require(['../views/Allot/allot_out'], resolve),
					meta: {
						title: '调拨出库'
					}
				},
				{
					path: '/allot_storage',
					name: 'allot_storage',
					component: resolve => require(['../views/Allot/allot_storage'], resolve),
					meta: {
						title: '调拨入库'
					}
				},
				{
					path: '/budget',
					name: 'budget',
					component: resolve => require(['../views/Budget/budget'], resolve),
					meta: {
						title: '预算管理'
					}
				}, {
					path: '/budget_detail',
					name: 'budget_detail',
					component: resolve => require(['../views/Budget/budget_detail'], resolve),
					meta: {
						title: '预算编辑'
					}
				}, {
					path: '/budget_category',
					name: 'budget_category',
					component: resolve => require(['../views/Archives/budget_category'], resolve),
					meta: {
						title: '预算类别'
					}
				},

				{
					path: '/budget_analysis',
					name: 'budget_analysis',
					component: resolve => require(['../views/Budget/budget_analysis'], resolve),
					meta: {
						title: '预算分析'
					}
				},
				{
					path: '/history_manage',
					name: 'history_manage',
					component: resolve => require(['../views/Asset/history_manage'], resolve),
					meta: {
						title: '期初资产导入'
					}
				},
				{
					path: '/history_manage_edit',
					name: 'history_manage_edit',
					component: resolve => require(['../views/Asset/history_manage_edit'], resolve),
					meta: {
						title: '历史资产录入'
					}
				},
				{
					path: '/move_manage',
					name: 'move_manage',
					component: resolve => require(['../views/Asset/move_manage'], resolve),
					meta: {
						title: '迁移管理'
					}
				},
				{
					path: '/move_manage_edit',
					name: 'move_manage_edit',
					component: resolve => require(['../views/Asset/move_manage_edit'], resolve),
					meta: {
						title: '迁移编辑'
					}
				},
				{
					path: '/scrap_manage',
					name: 'scrap_manage',
					component: resolve => require(['../views/Asset/scrap_manage'], resolve),
					meta: {
						title: '报废管理'
					}
				},
				{
					path: '/scrap_manage_edit',
					name: 'scrap_manage_edit',
					component: resolve => require(['../views/Asset/scrap_manage_edit'], resolve),
					meta: {
						title: '报废申请'
					}
				},
				{
					path: '/dev_sign_change',
					name: 'dev_sign_change',
					component: resolve => require(['../views/Asset/asset_sign_change'], resolve),
					meta: {
						title: '定位矫正'
					}
				},
				{
					path: '/area_manage',
					name: 'area_manage',
					component: resolve => require(['../views/Archives/area_manage'], resolve),
					meta: {
						title: '区域管理'
					}
				},
				{
					path: '/rode_manage',
					name: 'rode_manage',
					component: resolve => require(['../views/Archives/rode_manage'], resolve),
					meta: {
						title: '道路管理'
					}
				},
				{
					path: '/take_stock',
					name: 'take_stock',
					component: resolve => require(['../views/TakeStock/take_stock'], resolve),
					meta: {
						title: '资产盘点'
					}
				},
				{
					path: '/take_stock_detail',
					name: 'take_stock_detail',
					component: resolve => require(['../views/TakeStock/take_stock_detail'], resolve),
					meta: {
						title: '资产盘点编辑'
					}
				},
				{
					path: '/roadbucket_manage',
					name: 'roadbucket_manage',
					component: resolve => require(['../views/Asset/roadbucket_manage'], resolve),
					meta: {
						title: '占道施工'
					}
				},
				{
					path: '/roadbucket_manage_edit',
					name: 'roadbucket_manage_edit',
					component: resolve => require(['../views/Asset/roadbucket_manage_edit'], resolve),
					meta: {
						title: '占道施工申请'
					}
				},
				{
					path: '/customer_analysis',
					name: 'customer_analysis',
					component: resolve => require(['../views/AnalysisData/customer_analysis'], resolve),
					meta: {
						title: '客户分析'
					}
				},
				{
					path: '/market_analysis',
					name: 'market_analysis',
					component: resolve => require(['../views/AnalysisData/market_analysis'], resolve),
					meta: {
						title: '市场分析'
					}
				},
				{
					path: '/product_analysis',
					name: 'product_analysis',
					component: resolve => require(['../views/AnalysisData/product_analysis'], resolve),
					meta: {
						title: '产品分析'
					}
				},
				{
					path: '/asset_analysis',
					name: 'asset_analysis',
					component: resolve => require(['../views/AnalysisData/asset_analysis'], resolve),
					meta: {
						title: '资产分布'
					}
				}, {
					path: '/collision_bucket_group',
					name: 'collision_bucket_group',
					component: resolve => require(['../views/Archives/collision_bucket_group'],
						resolve),
					meta: {
						title: '碰撞端子绑定'
					}
				}, {
					path: '/device_replace_log',
					name: 'device_replace_log',
					component: resolve => require(['../views/Device/device_replace_log'], resolve),
					meta: {
						title: '设备更换记录'
					}
				}, {
					path: '/iotapp_na_manage',
					name: 'iotapp_na_manage',
					component: resolve => require(['../views/Archives/iotapp_na_manage'], resolve),
					meta: {
						title: '电信iot平台'
					}
				}, {
					path: '/iotapp_onenet_manage',
					name: 'iotapp_onenet_manage',
					component: resolve => require(['../views/Archives/iotapp_onenet_manage'], resolve),
					meta: {
						title: '移联iot平台'
					}
				}, {
					path: '/hk_device_manage',
					name: 'hk_device_manage',
					component: resolve => require(['../views/Hikvision/Device/hk_device'], resolve),
					meta: {
						title: '海康设备管理'
					}
				}, {
					path: '/led_device_manage',
					name: 'led_device_manage',
					component: resolve => require(['../views/LED/Device/led_device'], resolve),
					meta: {
						title: 'LED控制卡'
					}
				}, {
					path: '/led_device_edit',
					name: 'led_device_edit',
					component: resolve => require(['../views/LED/Device/led_device_edit'], resolve),
					meta: {
						title: 'LED控制卡编辑'
					}
				}, {
					path: '/led_cmd_log',
					name: 'led_cmd_log',
					component: resolve => require(['../views/LED/Log/led_cmd_log'], resolve),
					meta: {
						title: 'LED控制卡日志'
					}
				}, {
					path: '/tcp_service_manage',
					name: 'tcp_service_manage',
					component: resolve => require(['../views/TCP/Log/tcp_service_manage'], resolve),
					meta: {
						title: 'TCP服务管理'
					}
				}, {
					path: '/tcp_service_manage_his',
					name: 'tcp_service_manage_his',
					component: resolve => require(['../views/TCP/Log/tcp_service_manage_his'], resolve),
					meta: {
						title: 'TCP通讯历史'
					}
				}, {
					path: '/tcp_service_manage_log',
					name: 'tcp_service_manage_log',
					component: resolve => require(['../views/TCP/Log/tcp_service_manage_log'], resolve),
					meta: {
						title: 'TCP通讯日志'
					}
				}, {
					path: '/tcp_program_version',
					name: 'tcp_program_version',
					component: resolve => require(['../views/TCP/Program/tcp_program_version'],
						resolve),
					meta: {
						title: 'TCP固件版本'
					}
				}, {
					path: '/tcp_program_version_edit',
					name: 'tcp_program_version_edit',
					component: resolve => require(['../views/TCP/Program/tcp_program_version_edit'],
						resolve),
					meta: {
						title: 'TCP固件上传'
					}
				}, {
					path: '/furniture_manage',
					name: 'furniture_manage',
					component: resolve => require(['../views/Asset/furniture_manage'], resolve),
					meta: {
						title: '历史资产管理'
					}
				}, {
					path: '/furniture_manage_edit',
					name: 'furniture_manage_edit',
					component: resolve => require(['../views/Asset/furniture_manage_edit'], resolve),
					meta: {
						title: '城市家具录入'
					}
				}, {
					path: '/furniture_manage_detail',
					name: 'furniture_manage_detail',
					component: resolve => require(['../views/Asset/furniture_manage_detail'], resolve),
					meta: {
						title: '城市家具详情'
					}
				}, {
					path: '/project_approve',
					name: 'project_approve',
					component: resolve => require(['../views/Project/1_Project/project_approve.vue'],
						resolve),
					meta: {
						title: '立项'
					}
				}, {
					path: '/project_approve_edit',
					name: 'project_approve_edit',
					component: resolve => require([
						'../views/Project/1_Project/project_approve_edit.vue'
					], resolve),
					meta: {
						title: '立项编辑'
					}
				}, {
					path: '/tender',
					name: 'tender',
					component: resolve => require(['../views/Project/2_Tender/tender'], resolve),
					meta: {
						title: '招投标'
					}
				}, {
					path: '/tender_detail',
					name: 'tender_detail',
					component: resolve => require(['../views/Project/2_Tender/tender_detail'], resolve),
					meta: {
						title: '招标编辑'
					}
				}, {
					path: '/tender_analysis',
					name: 'tender_analysis',
					component: resolve => require(['../views/Project/2_Tender/tender_analysis'],
						resolve),
					meta: {
						title: '招标分析'
					}
				}, {
					path: '/contract_manage',
					name: 'contract_manage',
					component: resolve => require(['../views/Project/3_Contract/contract_manage.vue'],
						resolve),
					meta: {
						title: '合同'
					}
				},
				{
					path: '/unitcontract',
					name: 'unitcontract',
					component: resolve => require(['../views/Project/3_Contract/unitcontract.vue'],
						resolve),
					meta: {
						title: '合同管理'
					}
				},
				{
					path: '/contractdetail',
					name: 'contractdetail',
					component: resolve => require(['../views/Project/3_Contract/contractdetail.vue'],
						resolve),
					meta: {
						title: '合同编辑'
					}
				}, {
					path: '/project_check',
					name: 'project_check',
					component: resolve => require(['../views/Project/4_Check/project_check.vue'],
						resolve),
					meta: {
						title: '验收'
					}
				}, {
					path: '/project_check_edit',
					name: 'project_check_edit',
					component: resolve => require(['../views/Project/4_Check/project_check_edit.vue'],
						resolve),
					meta: {
						title: '验收编辑'
					}
				}, {
					path: '/project_aduit',
					name: 'project_aduit',
					component: resolve => require(['../views/Project/5_Aduit/project_aduit.vue'],
						resolve),
					meta: {
						title: '审计'
					}
				}, {
					path: '/project_aduit_edit',
					name: 'project_aduit_edit',
					component: resolve => require(['../views/Project/5_Aduit/project_aduit_edit.vue'],
						resolve),
					meta: {
						title: '审计编辑'
					}
				}, {
					path: '/project_summary',
					name: 'project_summary',
					component: resolve => require(['../views/Project/6_Summary/project_summary.vue'],
						resolve),
					meta: {
						title: '项目汇总'
					}
				}, {
					path: '/settle_manage',
					name: 'settle_manage',
					component: resolve => require(['../views/Settle/settle_manage.vue'], resolve),
					meta: {
						title: '理赔管理'
					}
				}, {
					path: '/settle_edit',
					name: 'settle_edit',
					component: resolve => require(['../views/Settle/settle_edit.vue'], resolve),
					meta: {
						title: '理赔编辑'
					}
				}, {
					path: '/settle_summary',
					name: 'settle_summary',
					component: resolve => require(['../views/Settle/settle_summary.vue'], resolve),
					meta: {
						title: '理赔汇总'
					}
				}, {
					path: '/settle_link',
					name: 'settle_link',
					component: resolve => require(['../views/Settle/settle_link.vue'], resolve),
					meta: {
						title: '理赔联系人'
					}
				}, {
					path: '/settle_insurance',
					name: 'settle_insurance',
					component: resolve => require(['../views/Settle/settle_insurance.vue'], resolve),
					meta: {
						title: '理赔单位'
					}
				}, {
					path: '/complain_manage',
					name: 'complain_manage',
					component: resolve => require(['../views/Complain/complain_manage.vue'], resolve),
					meta: {
						title: '投诉管理'
					}
				}, {
					path: '/complain_edit',
					name: 'complain_edit',
					component: resolve => require(['../views/Complain/complain_edit.vue'], resolve),
					meta: {
						title: '投诉编辑'
					}
				}, {
					path: '/complain_follow',
					name: 'complain_follow',
					component: resolve => require(['../views/Complain/complain_follow.vue'], resolve),
					meta: {
						title: '投诉跟进'
					}
				}, {
					path: '/complain_summary',
					name: 'complain_summary',
					component: resolve => require(['../views/Complain/complain_summary.vue'], resolve),
					meta: {
						title: '投诉汇总'
					}
				}, {
					path: '/dev_lowpower',
					name: 'dev_lowpower',
					component: resolve => require([
						'../views/AnalysisData/DevAbnormal/dev_lowpower.vue'
					], resolve),
					meta: {
						title: '设备低电量统计'
					}
				}, {
					path: '/dev_report_sum',
					name: 'dev_report_sum',
					component: resolve => require(['../views/AnalysisData/DevAbnormal/dev_report_sum'],
						resolve),
					meta: {
						title: '设备上报汇总'
					}
				}, {
					path: '/dev_report_detail',
					name: 'dev_report_detail',
					component: resolve => require([
						'../views/AnalysisData/DevAbnormal/dev_report_detail'
					], resolve),
					meta: {
						title: '设备上报详情'
					}
				},
				{
					path: '/dlwb_program_version',
					name: 'dlwb_program_version',
					component: resolve => require([
							'../views/RoadGuards/Program/dlwb_program_version.vue'
						],
						resolve),
					meta: {
						title: 'MQTT固件'
					}
				},
				{
					path: '/dlwb_led_group',
					name: 'dlwb_led_group',
					component: resolve => require([
							'../views/RoadGuards/LedGroup/dlwb_led_group.vue'
						],
						resolve),
					meta: {
						title: '道路精灵LED灯组'
					}
				},
				{
					path: '/dlwb_led_group_edit',
					name: 'dlwb_led_group_edit',
					component: resolve => require([
							'../views/RoadGuards/LedGroup/dlwb_led_group_edit.vue'
						],
						resolve),
					meta: {
						title: '道路精灵LED灯组编辑'
					}
				},
				{
					path: '/dlwb_air_sensor',
					name: 'dlwb_air_sensor',
					component: resolve => require([
							'../views/RoadGuards/AirSensor/dlwb_air_sensor.vue'
						],
						resolve),
					meta: {
						title: '环境传感器'
					}
				},
				{
					path: '/dlwb_air_sensor_edit',
					name: 'dlwb_air_sensor_edit',
					component: resolve => require([
							'../views/RoadGuards/AirSensor/dlwb_air_sensor_edit.vue'
						],
						resolve),
					meta: {
						title: '环境传感器编辑'
					}
				},
				{
					path: '/dlwb_air_sensor_log',
					name: 'dlwb_air_sensor_log',
					component: resolve => require([
							'../views/RoadGuards/AirSensor/dlwb_air_sensor_log.vue'
						],
						resolve),
					meta: {
						title: '环境传感器日志'
					}
				}
			]
		},
		{
			path: '/login',
			name: 'login',
			component: resolve => require(['../views/Login.vue'], resolve)
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js